module.exports = __webpack_public_path__ + "static/media/Charla.19e8e0a9.png";